import { styled } from '@mui/material';

export const ContentW = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 742px;
  margin: 0 auto;
`;
